import React from 'react';
import { Grid } from '@material-ui/core';
import { Text } from 'library';
import { Colors } from '../../../constants';
import IndeedPaper from './components/IndeedPaper';
import TandemFreeIconText from './components/TandemFreeIconText';
import AppStoreButton from '../AppStoreButton';
import CalendarIcon from 'assets/icons/indeed-home/calendar.svg';
import FindIcon from 'assets/icons/indeed-home/find.svg';
import PayIcon from 'assets/icons/indeed-home/pay.svg';

const TandemFreeValueProp = () => {
    return (
        <IndeedPaper>
            <Grid container direction="column" spacing={1}>
                <Grid item container direction="row" justify="space-between" xs={12}>
                    <Grid item md={8} xs={12} style={{ marginTop: 10 }}>
                        <Text variant="h1" textStyle={{ fontFamily: 'PT Serif' }}>
                            Tandem is the only FREE platform to find care jobs.
                        </Text>
                    </Grid>
                    <Grid item style={{ marginTop: 10 }}>
                        <AppStoreButton tracking="Tandem Free Value Prop" />
                    </Grid>
                </Grid>
                <Grid item container direction="row" spacing={1} xs={12}>
                    <Grid item>
                        <TandemFreeIconText icon={<CalendarIcon />}>
                            Customize your preferences and schedule.
                        </TandemFreeIconText>
                    </Grid>
                    <Grid item>
                        <TandemFreeIconText icon={<FindIcon />}>
                            Find child care, house cleaning jobs, pet care jobs and more!
                        </TandemFreeIconText>
                    </Grid>
                    <Grid item>
                        <TandemFreeIconText icon={<PayIcon />}>
                            <Grid container>
                                <Grid item>Get paid more</Grid>
                                <Grid item style={{ marginLeft: 4 }}>
                                    <Text variant="body2" color={Colors.mediumRed}>
                                        (105%)
                                    </Text>
                                </Grid>
                                <Grid>.</Grid>
                            </Grid>
                        </TandemFreeIconText>
                    </Grid>
                </Grid>
            </Grid>
        </IndeedPaper>
    );
};

export default TandemFreeValueProp;
